import React, { useState, useEffect } from "react";
import { Link} from "react-router-dom";
import { getDoc, doc, updateDoc} from "firebase/firestore";
import { db } from "../firebase-config/firebase";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);


const ShowAdult = () => {
    const [citas, setCitas] = useState([])
    const [nombre, setNombre] = useState('')
    const [apellidos, setApellidos] = useState('')
    const [recetas, setRecetas] = useState([])
    const [edad, setEdad] = useState('')
    const [cedula, setCedula] = useState('')
    const [patologias, setPatologias] = useState('')
    const { id } = useParams()
    const navigate = useNavigate()

    const getAdultoById = async (id) => {

        const adulto = await getDoc(doc(db, "adultosm", id))

        setCitas(adulto.data().citas)
        setRecetas(adulto.data().recetas)
        setNombre(adulto.data().nombre)
        setApellidos(adulto.data().apellidos)
        setEdad(adulto.data().edad)
        setCedula(adulto.data().cedula)
        if (adulto.data().patologias === undefined) {
            setPatologias("Sin Patologias")
        }else {
            setPatologias(adulto.data().patologias)
        }

    }

    const to12h = (time) => {
        const div = time.split(":");
        const hora = Number(div[0]);
        if (hora > 12) {
            const hora12 = hora - 12
            if (hora12 < 10) {
                return "0" + hora12 + ":" + div[1] + " PM"
            }
            
            return hora12 + ":" + div[1] + " PM"

        }else{
            return time + " AM"
        }

    }
    const deleteDate = async (e, index) => {
        e.preventDefault()
        const adultodoc = doc(db, "adultosm", id)
        const adulto = await getDoc(adultodoc)
        const datos = adulto.data()
        if (datos.citas === undefined) {
           return;
        }
        console.log(datos.citas)
        datos.citas.splice(index, 1)
        
        const data = {
          citas: datos.citas
        }
        MySwal.fire({     
          icon: "success",
          title: "Cita Eliminada!",
          showConfirmButton: false,
          timer: 1500
        });
        await updateDoc(adultodoc, data)
        window.location.reload()
        
      }
      const deleteMeds = async (e, index) => {
        e.preventDefault()
        const adultodoc = doc(db, "adultosm", id)
        const adulto = await getDoc(adultodoc)
        const datos = adulto.data()
        if (datos.recetas === undefined) {
           return;
        }
        console.log(datos.recetas)
        datos.recetas.splice(index, 1)
        
        const data = {
          recetas: datos.recetas
        }
        MySwal.fire({     
          icon: "success",
          title: "Receta Eliminada!",
          showConfirmButton: false,
          timer: 1500
        });
        await updateDoc(adultodoc, data)
        window.location.reload()
        
      }

    useEffect(() => {
        getAdultoById(id)
        //eslint-disable-next-line
    }, [])

    return (
        <>
            <div className="container">
                <div className='Header'>
                    <div className="row"> <h1>Informacion Personal</h1> </div>
                    <div className='underlineC'></div>
                </div>

                <div className="row">

                    <div className="col">

                        <div className="row">

                            <input disabled className="cornerSearch" value={nombre + " " + apellidos} type="text"></input>

                        </div>

                        <table className="table table-dark table-hover tshadow">
                            <thead>

                                <tr>
                                    <th>Cedula</th>
                                    <th>Nacimiento</th>
                                    <th>Patologias</th>
                                    <th>Editar</th>
                                </tr>

                            </thead>
                            <tbody>
                                <tr>
                                    <td>{cedula}</td>
                                    <td>{edad}</td>
                                    <td>{patologias}</td>
                                    <td>
                                        <Link to={`/home/edit/${id}`} className="btn btn-light m-1"><i class="fa-solid fa-pen-to-square"></i></Link>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='Header'>
                    <div className="row"> <h1>Recetas</h1> <Link to={`/home/createMeds/${id}`} className="btn btn-outline-secondary m-1" >Nueva Receta</Link> </div>
                    <div className='underlineC'></div>
                </div>

                <div className="row">

                    <div className="col">

                        <table className="table table-dark table-hover tshadow">
                            <thead>

                                <tr>
                                    <th>Medicamento</th>
                                    <th>Dosis</th>
                                    <th>Horario</th>
                                    <th>Eliminar</th>
                                </tr>

                            </thead>
                            <tbody>

                                {recetas.map((receta, index) => (

                                    <tr id={index}>
                                        <td>{receta.medicamento}</td>
                                        <td>{receta.dosis}</td>
                                        <td>{receta.horario}</td>
                                        <td>
                                            <button className="btn btn-danger m-1" onClick={(e) => { deleteMeds(e, index) }} ><i className="fa-solid fa-trash-can"></i></button>
                                        </td>
                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>
                <div className='Header'>
                    <div className="row"> <h1>Citas</h1>
                        <Link to={`/home/createDate/${id}`} className="btn btn-outline-secondary m-1" >Nueva Cita</Link>  </div>
                    <div className='underlineC'></div>
                </div>

                <div className="row">

                    <div className="col">

                        <table className="table table-dark table-hover tshadow">
                            <thead>

                                <tr>
                                    <th>Lugar</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Eliminar</th>

                                </tr>

                            </thead>
                            <tbody>
                                {citas.map((cita, index) => (
                                    <tr id={index}>
                                        <td>{cita.lugar}</td>
                                        <td>{cita.fecha}</td>
                                        <td>{to12h(cita.hora)}</td>
                                        <td>
                                            <button className="btn btn-danger m-1" onClick={(e) => { deleteDate(e, index) }}><i className="fa-solid fa-trash-can"></i></button>
                                        </td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </>

    )
}

export default ShowAdult